import { getLocale } from "../runtime";

const sv_trackorderreferencelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Din orderreferens`
};

const trackorderreferencelabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackorderreferencelabel(inputs)
	return "trackOrderReferenceLabel";
};

export { trackorderreferencelabel as "trackOrderReferenceLabel" };